// NOTE:
// This file should contain simple JS that is not worthy of a JQuery plugin,
// not required by one, and is used site-wide. For example, the simple bit
// of code that makes the program switcher select box submit its form.

$(document).ready(function(){

    $.ajaxSetup({
        cache: false
    });

    $.ajaxPrefilter(function(options, originalOptions, jqXHR) {
        var success = options.success;
        options.success = function(data, textStatus, jqXHR) {
            // override success handling
            var $data;
            try {
                $data = $(data);
            } catch (e) {
                if(typeof(success) === "function") return success(data, textStatus, jqXHR);
            }
            // Handle login forms if a dialog is not open
            if($data.find('#j_username').size()>0 && $('.ui-dialog:visible').size()==0) {
                // user session timed out
                $('#container').empty().replaceWith($data.find('#container'));
                $('#container').msxiinit();
            }
            else
            {
                // Otherwise let the default success handler continue
                if(typeof(success) === "function") return success(data, textStatus, jqXHR);
            }
        };
        var error = options.error;
        options.error = function(jqXHR, textStatus, errorThrown) {
            // override error handling
            if (!options.supressErrorDialog) {
                handleAjaxError(jqXHR, textStatus);
            }
            if(typeof(error) === "function") return error(jqXHR, textStatus, errorThrown);
        };
    });

    if ($.cookie && $.cookie("hide_password_reminder") == null)
    {
        $('#password-expire-warning').show();
    }

    $('.hide-password-expire-warning').click(function(){
        $.cookie("hide_password_reminder", "true", {path: '/fpm'});
        $('#password-expire-warning').slideUp(100);
    });

    // FPM-5801 FPM-5797 FPM-5621
    // Firefox no longer supports autocomplete=off for password fields: https://bugzilla.mozilla.org/show_bug.cgi?id=956906
    // To prevent the browser auto-filling login and password in a user edit or profile page we have fake hidden and disabled login and password fields.
    // The fake fields will be populated by the browser but the user cannot see them. We then overwrite the fake login name with the real login name.
    // We keep the fake login name in sync with the real login name so that browser save password prompt is correctly populated.
    // To the user it is all seamless and looks as if autocomplete=off is working correctly
    var $fakeLogin = $('input.fake-login');
    var $realLogin = $('input.real-login');
    $fakeLogin.val($realLogin.val());
    $realLogin.change(function(){
        $fakeLogin.val($realLogin.val());
    });
});

/*window.onerror = function(msg, file, line, col, error) {
 $('body').append("<pre>" + error.stack + '</pre>');
 // callback is called with an Array[StackFrame]
 StackTrace.fromError(error).then(callback).catch(errback);
 };*/

/*window.onerror = function (msg, url, lineNo, columnNo, error) {
 // ... handle error ...
 if (console) {
 console.log("Error:" + error.stack);
 }
 else {
 $('body').append("<pre>" + error.stack + '</pre>');
 }
 // return false;
 };*/



/**
 * Deal with an ajax error. In general the global error handler will be run but this can be used if you need to do custom logic on error and still show a
 * consistent error message. For now this is just a crappy alert..
 *
 * @param xmlHttpRequest
 * @param errorText
 */
function handleAjaxError(xmlHttpRequest,errorText) {
    if ($('.ui-dialog .error-handled').size() == 0) {

        // A status of 0 indicates that the xmlHttpRequest was aborted, probably by the user interrupting the request by clicking a link. We don't want to show an error for this.
        if (xmlHttpRequest.status != 0) {
            var $dialog = $('<div></div>');
            var $response = $(xmlHttpRequest.responseText);
            var title = $response.find('#main > h2').text() || translate('Unknown Error');

            $dialog.dialog($.extend({
                title: title,
                autoOpen: false
            }, $.fn.msxidialog.defaults.dialogOptions));

            if (xmlHttpRequest.responseText) {
                $.fn.msxidialog.customFillDialog($dialog, $response, $.fn.msxidialog.defaults);
            }
            else {
                $dialog.html(title);
            }

            $dialog.msxiinit();
            $dialog.dialog('open');
        }
    }
    else {
        $('.ui-dialog .error-handled').removeClass('error-handled');
    }
}


/**
 * Handle a general JS error by creating and popping up a dialogue box to the user containing the specified text/markup.
 *
 * IMPORTANT: errorDialog expects the provided errorTitle and markup included in errorText to already be translated
 * into the user's language.
 *
 * @param {string} errorTitle - Title of error dialog
 * @param {string|markup} errorText - Body of error dialog
 */
function errorDialog(errorTitle, errorText) {
    if ($('.ui-dialog .error-handled').size() == 0) {

        var $dialog = $('<div></div>');
        errorTitle = errorTitle || translate('Unknown Error');

        $dialog.dialog($.extend({
            title: errorTitle,
            autoOpen: false
        }, $.fn.msxidialog.defaults.dialogOptions));

        if (errorText) {
            $dialog.html(errorText);
        }

        $dialog.msxiinit();
        $dialog.dialog('open');
    }
    else {
        $('.ui-dialog .error-handled').removeClass('error-handled');
    }
}

//Object for passing values from freemarker to javascript where there is no DOM element to set the data on
var freemarkerValues = {};
